import React, { useState } from 'react';
import styled from 'styled-components';

import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';
import Row from 'components/Common/Row';

import AlwaysOnPreviewDialog from './AlwaysOnPreviewDialog';
import ValidationPanel from './ValidationPanel';
import { useKbValidation } from './KbValidationProvider';

// The validation summary + always-on preview, from the old KnowledgeBaseTab
// footer. Reads the shared KbValidationProvider so it never triggers its own
// fetch.

const DrawerDiv = styled.div`
  border-top: 1px solid var(--color-border-secondary);
  padding: 12px 16px;
`;

const ValidationDrawer = () => {
  const { validation, isValidating, revalidate } = useKbValidation();
  const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);

  return (
    <DrawerDiv>
      <Row centerAlign spaceBetween style={{ marginBottom: 8 }}>
        <Typography.Body type="Label">Validation</Typography.Body>
        <Row centerAlign style={{ gap: 8 }}>
          <Button
            type="Ghost"
            size="Small"
            label="View always-on block"
            onClick={() => setIsPreviewOpen(true)}
          />
          <Button
            type="Ghost"
            size="Small"
            label={isValidating ? 'Checking…' : 'Re-check'}
            isDisabled={isValidating}
            onClick={revalidate}
          />
        </Row>
      </Row>
      <ValidationPanel validation={validation} />
      {isPreviewOpen && (
        <AlwaysOnPreviewDialog close={() => setIsPreviewOpen(false)} />
      )}
    </DrawerDiv>
  );
};

export default ValidationDrawer;
